import { render, staticRenderFns } from "./EventHistoryTenderCreatedAsNewStageParams.vue?vue&type=template&id=18ca4802"
import script from "./EventHistoryTenderCreatedAsNewStageParams.vue?vue&type=script&lang=js"
export * from "./EventHistoryTenderCreatedAsNewStageParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports